import ExternalAuthentication from '../ExternalAuthentication/ExternalAuthentication';
import { Link } from 'react-router-dom';
import { useLocation } from 'react-router-dom';
import { Mail } from '../PasswordRecoveryBox/Mail/Mail';
import { useEffect, useState } from 'react';
import { ModalErr } from '../Modal/ModalErr/ModalErr';
import { validationEmail } from '../../common/validationFunc';
import { KonstantionAuthHttps, KonstantionAuthHttp } from '../../fetchUrls';
import { TitlePage } from '../TitlePage/TitlePage';
import {
  InputDinamycPlaceholder,
  Checkbox,
  ButtonBasic,
} from '@lk-gtcom/ecomlab-components';
import './RegistrationBox.scss';
import { TextPage } from '../TextPage/TextPage';

const RegistrationBox = ({ admin = false }) => {
  const location = useLocation()
  const [email, setEmail] = useState('');
  const [password, setPassword] = useState('');
  const [name, setName] = useState('');
  const [personalData, setPersonalData] = useState(false);
  const [newsSubscription, setNewsSubscription] = useState(false);
  const [hidePassword, setHidePassword] = useState(false);
  const [inValid, setInvalid] = useState(false);

  const [err, setErr] = useState(false);
  const [errPassword, setErrPassword] = useState(false);
  const [errEmail, setErrEmail] = useState(false);
  const [errName, setErrName] = useState(false);

  const [isModal, setIsModal] = useState(false);
  const [isModalRegistration, setIsModalRegistration] = useState(false);


  const deleteErrNotofication = () => {
    setErrPassword(false);
    setErr(false);
    setErrEmail(false);
    setInvalid(false);
    setErrName(false);
  };

  const handlerSetEmail = (e) => {
    setEmail(e);
    deleteErrNotofication();
  };

  const handlerSetPassword = (e) => {
    setPassword(e);
    deleteErrNotofication();
  };

  const handlerSetName = (e) => {
    setName(e);
    deleteErrNotofication();
  };

  const activeTypeIput = hidePassword ? 'text' : 'password';

  // переменная для проверки
  let formBig = {
    name,
    email,
    password,
    mailing_allowed: newsSubscription,
    cookies_allowed: true,
  };

  // Для рефералов
  const urlParams = new URLSearchParams(window.location.search);
  const referrer_token = urlParams.get('utm_ref');

  const handlerSubmit = (e) => {
    let url = `${KonstantionAuthHttps}/web/register${referrer_token ? `?referrer_token=${referrer_token}` : ''}`;


    const headers = {
      'Content-type': 'application/json',
      'Accept': 'application/json',
      'portal-id': '4',
    };

    fetch(url, { method: 'POST', body: JSON.stringify(formBig), headers })
      .then((response) => response.json())
      .then((data) => {
        if (data?.detail == 'REGISTER_USER_ALREADY_EXISTS') {
          setErr(true);
        }
        if (data?.detail == 'Not Found') {
          setIsModal(true);
        }

        if (data?.message == 'User successfully registered') {
          setIsModalRegistration(true);
        }
      })
      .catch((err) => {
        setIsModal(true);
        console.error(err);
      });
  };

  const checkInputField = () => {
    const regexPassword =
      /(?=.*[0-9])(?=.*[a-z])(?=.*[A-Z])[0-9a-zA-Z!@#$%^&*]{6,}/;

    if (!regexPassword.test(password)) {
      setErrPassword(true);
    }

    if (!validationEmail(email)) {
      setErrEmail(true);
    }

    if (!name) {
      setErrName(true);
    }

    if (
      !regexPassword.test(password) ||
      !validationEmail(email) ||
      !name ||
      !personalData
    ) {
      return;
    } else {
      handlerSubmit();
    }
  };

  // Сохранение query
  const [query, setQuery] = useState('');

  useEffect(() => {
    const params = new URL(document.location).searchParams;
    let query_params = params.get('utm_ref');
    setQuery(query_params);
    console.log('utm_ref ' + query_params);
  }, [new URL(document.location)]);

  return (
    <>
      {isModal && (
        <ModalErr isModal={isModal} setIsModal={(e) => setIsModal(e)} />
      )}
      {isModalRegistration && (
        <Mail
          title="Регистрация прошла успешно"
          text={`Проверьте e-mail, мы выслали вам письмо для подтверждения регистрации`}
          setIsModal={(e) => setIsModalRegistration(e)}
        />
      )}
      <form
        className="autorization"
        style={{ marginTopp: '150px' }}
        onSubmit={(e) => e.preventDefault()}
        spellCheck="false"
      >
        <div
          className="title_wrapper"
          style={{ display: 'flex', gap: '1em', alignItems: 'center' }}
        >
          <TitlePage
            title='Регистрация'
            style={{ fontSize: '22px' }}
          />
        </div>

        <ExternalAuthentication />

        <TextPage
          text={<><span style={{ color: '#94A3B8' }}>Или через</span> e-mail</>}
        />

        <InputDinamycPlaceholder
          onChange={(e) => handlerSetName(e)}
          type="text"
          err={errName}
          textErr={'Введите имя'}
          placeholder="Введите имя"
          autoComplete={false}
          required
        />

        <div className={inValid ? 'input-with-btn_active' : 'input-with-btn'}>
          <InputDinamycPlaceholder
            onChange={(e) => handlerSetEmail(e)}
            type="e-mail"
            err={errEmail}
            textErr={'Неверный email'}
            placeholder="Введите адрес электронной почты"
            autoComplete={false}
            required
          />
        </div>

        <InputDinamycPlaceholder
          onChange={(e) => handlerSetPassword(e)}
          type={activeTypeIput}
          err={errPassword}
          textErr={'Пароль не соответствует требованиям'}
          placeholder="Введите пароль"
          passwordTooltip
          autoComplete={false}
          tooltip="Пароль должен содержать не менее 8 символов, цифры и заглавные буквы"
          required
        />

        {err && (
          <div className="err-box">
            <span className="text text_red">
              Пользователь с таким логином уже существует
            </span>
          </div>
        )}

        <div className="checkbox__box_registration">
          <Checkbox
            value={personalData}
            onChange={setPersonalData}
          >
            <span className="text">
              Я даю согласие на обработку своих персональных данных согласно
              <Link
                className="blue"
                onClick={(e) =>
                  window.open(
                    'https://ecomru.ru/ru/article/politika_konfidentsialnosti/6734',
                    '_blank'
                  )
                }
              > политике конфиденциальности</Link>
            </span>
          </Checkbox>

          <Checkbox
            value={newsSubscription}
            onChange={setNewsSubscription}
          >
            <span className="text">
              Хочу получать полезные новости и специальные предложения от
              Ecomru.ru
            </span>
          </Checkbox>
        </div>
        <div className="bottom-box-registration">
          <ButtonBasic
            blue
            text="Зарегистрироваться"
            size="40px"
            width="100%"
            disabled={
              !(
                (password?.length > 0) &
                (email?.length > 0) &
                (name?.length > 0) &
                personalData
              )
            }
            onClick={(e) => {
              e.preventDefault();
              checkInputField();
            }}
          />

        </div>
        <div className="bottom-box">
          <TextPage
            text='Уже есть аккаунт ?'
          />
          <Link to={`/auth${location.search}`} className="text_blue">
            Войти
          </Link>
        </div>
      </form>
    </>
  );
};

export { RegistrationBox };
